import React from "react";

import QuestionnaireBuilder from "@Features/questionnaireBuilder";

const QuestionnairesPage = () => {
    return <QuestionnaireBuilder />;
};
export default QuestionnairesPage;
